import axios from "axios"

export const getRequest = (route:string) => {
	return new Promise<any>((resolve, reject)=>
		axios.get(route)
			.then((response)=>resolve(response))
			.catch((error)=>reject(error)))
}

export const postRequest = async (route:string, payloads:any) => {
	const headers = {}
	return new Promise<any>((resolve, reject)=>
		axios.post<any>(route, payloads, 
			{ 
				headers
			})
			.then((response)=>resolve(response))
			.catch((error)=>reject(error)))
}

export const putRequest = async (route:string, payloads:any) => {
	const headers = {}
	return new Promise<any>((resolve, reject)=>
		axios.put(route, payloads,
			{ 
				headers
			})
			.then((response)=>resolve(response))
			.catch((error)=>reject(error)))
}

export const deleteRequest = async (route:string) => {
	const headers = {}
	return new Promise<any>((resolve, reject)=>
		axios.delete(route, {
			headers
		})
			.then((response)=>resolve(response))
			.catch((error)=>reject(error)))
}